import type { SVGProps } from 'react';
const SvgKeyboardHide = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#keyboard_hide_svg__a)">
      <path
        fill="currentColor"
        d="M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm-9 3h2v2h-2V6Zm0 3h2v2h-2V9ZM8 6h2v2H8V6Zm0 3h2v2H8V9Zm-1 2H5V9h2v2Zm0-3H5V6h2v2Zm9 7H8v-2h8v2Zm0-4h-2V9h2v2Zm0-3h-2V6h2v2Zm3 3h-2V9h2v2Zm0-3h-2V6h2v2Zm-7 15 4-4H8l4 4Z"
      />
    </g>
    <defs>
      <clipPath id="keyboard_hide_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgKeyboardHide;
